import { injectable } from "inversify";
import DashboardRepository from "../../repositories/dashboard.repository";
import { Either, isRight, right } from "fp-ts/lib/Either";
import ErrorEntity from "../../entities/error.entity";
import QACommentEntity from "../../entities/qa_comment.entity";

interface props {
    dashboardRepository: DashboardRepository;
}

export interface GetAgentCommentsParams {
    agentId: string;
    startDate: Date;
    endDate: Date;
}

@injectable()
class GetAgentCommentsUseCase {
    private dashboardRepository: DashboardRepository;

    constructor({ dashboardRepository }: props) {
        this.dashboardRepository = dashboardRepository;
    }

    public call = async (params: GetAgentCommentsParams): Promise<Either<ErrorEntity, QACommentEntity[]>> => {
        const response = await this.dashboardRepository.getAgentComments(params);
        if (isRight(response)) {
            return right(response.right);
        }
        return response;
    }
}

export default GetAgentCommentsUseCase;

export const GetAgentCommentsUseCaseName = "GetAgentCommentsUseCase";